import IconButton from "@/components/atoms/IconButton";
import { ITableHeaderComponentProps } from "@/interfaces/Table";
import { faFilter, faPlus, faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import { ElementRef, FC, useRef } from "react";
import { Button, Col, FormControl, InputGroup, Row } from "react-bootstrap";
import StoreInstructorModal from "../modals/instructors/StoreInstructorModal";

const AllInstructorsHeader: FC<ITableHeaderComponentProps> = ({
  onQueryChange,
  onShowFilters,
  smallFilters,
  query = "",
}) => {
  const StoreInstructorModalRef =
    useRef<ElementRef<typeof StoreInstructorModal>>(null);

  return (
    <div className="d-lg-flex justify-content-between">
      <StoreInstructorModal ref={StoreInstructorModalRef} />
      <Row className="flex-between-center gy-2 px-x1">
        <Col xs="auto" className="pe-0">
          <h6 className="mb-0">Formateurs</h6>
        </Col>
        <Col xs="auto">
          <InputGroup className="position-relative input-search-width">
            <FormControl
              size="sm"
              id="search"
              type="search"
              className="shadow-none"
              placeholder="Nom, email ou téléphone"
              aria-label="Rechercher un formateur"
              value={query}
              onChange={(e) => onQueryChange(e.target.value)}
            />
            <Button
              aria-label="Rechercher"
              onClick={() => onQueryChange(query)}
              size="sm"
              variant="outline-secondary"
              className="border-300 hover-border-secondary"
            >
              <FontAwesomeIcon icon={faSearch} />
            </Button>
          </InputGroup>
        </Col>
      </Row>
      <div className="border-bottom border-200 my-3"></div>
      <div className="d-flex align-items-center justify-content-between justify-content-lg-end px-x1">
        {!!onShowFilters && (
          <>
            <IconButton
              variant="nolina-default"
              size="sm"
              icon={faFilter}
              transform="shrink-4"
              iconAlign="middle"
              onClick={onShowFilters}
              className={classNames({ "d-xl-none": !smallFilters })}
            >
              <span
                className={classNames("ms-1", {
                  "d-none d-sm-inline-block": !smallFilters,
                })}
              >
                Filtres
              </span>
            </IconButton>
            <div
              className={classNames("bg-300 mx-3", {
                "d-none d-lg-block d-xl-none": !smallFilters,
                "d-none d-lg-block": smallFilters,
              })}
              style={{ width: "1px", height: "29px" }}
            ></div>
          </>
        )}
        <div id="orders-actions">
          <IconButton
            variant="nolina-default"
            size="sm"
            icon={faPlus}
            onClick={() => StoreInstructorModalRef.current?.showOrHiddenModal()}
            transform="shrink-3"
            iconAlign="middle"
          >
            <span className="d-none d-sm-inline-block d-xl-none d-xxl-inline-block ms-1">
              Nouveau
            </span>
          </IconButton>
        </div>
      </div>
    </div>
  );
};

export default AllInstructorsHeader;
